import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/surajsajjan/Desktop/shiksham-landing-page/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/surajsajjan/Desktop/shiksham-landing-page/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/shiksham-landing-page/src/app/components/CoursesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/shiksham-landing-page/src/app/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/shiksham-landing-page/src/app/components/LocationCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/shiksham-landing-page/src/app/components/OnlineOfflineSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/shiksham-landing-page/src/app/components/ProcessSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/shiksham-landing-page/src/app/components/ResultsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/shiksham-landing-page/src/app/components/StudentSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/shiksham-landing-page/src/app/components/TrustIntro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/surajsajjan/Desktop/shiksham-landing-page/src/components/Header.tsx");
